import { FC, ReactNode } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

export const EventListLayout: FC<{
  children: ReactNode;
  className?: string;
  id: string;
}> = ({ children, className, id }) => {
  return (
    <div id={id} className={cn('flex flex-col gap-6', className)}>
      {children}
    </div>
  );
};

export const EventItemLayout: FC<{
  banner: ReactNode;
  milestones: ReactNode;
  leaderboard?: ReactNode;
  id: string;
}> = ({ banner, milestones, leaderboard, id }) => {
  return (
    <div id={id}>
      {banner}
      <div className="mt-6 md:mt-10">{milestones}</div>
      {leaderboard && <div className="mt-6">{leaderboard}</div>}
    </div>
  );
};
